import moment from 'moment';
import React, { createContext, useContext, useState } from 'react';
import styled from 'styled-components';
import { AutoSuggest } from 'components/Form/AutoSuggest';

const thisYear = Number(moment().format('YYYY'));

const LabelText = styled.div`
  color: ${(props) => props.theme.colors.text.black};
  font-size: 16px;
  padding-left: 5px;
  margin-bottom: 6px;
  margin-right: 10px;

  @media (min-width: 500px) {
    font-size: 17px;
  }
`;

const EventYearFilterContext = createContext();

export const EventYearFilterProvider = ({ children }) => {
  const [yearFilter, setYearFilter] = useState(thisYear);
  return (
    <EventYearFilterContext.Provider value={{ yearFilter, setYearFilter }}>
      {children}
    </EventYearFilterContext.Provider>
  );
};

export const useEventYearFilter = () => {
  const context = useContext(EventYearFilterContext);
  if (context === undefined) {
    throw new Error(
      'useEventYearFilter must be used within an EventYearFilterProvider'
    );
  }
  return context;
};

export const withEventYearFilterContext = (Component) => {
  return (props) => (
    <EventYearFilterProvider>
      <Component {...props} />
    </EventYearFilterProvider>
  );
};

export const YearDropdown = ({ onSelect, showLabel, setYear, customYear }) => {
  const { yearFilter, setYearFilter } = useEventYearFilter();
  const years = [thisYear - 2, thisYear - 1, thisYear, thisYear + 1];
  return (
    <>
      {showLabel ? <LabelText>Year</LabelText> : null}
      <AutoSuggest
        placeholder="Filter"
        options={years.map((year) => ({
          label: String(year),
          value: year,
        }))}
        value={{
          label: String(customYear ?? yearFilter),
          value: customYear ?? yearFilter,
        }}
        onChange={(year) => {
          if (onSelect) {
            onSelect(year?.value ? year : { value: thisYear });
          }
          setYearFilter(year?.value ? Number(year.value) : thisYear);
          if (setYear) setYear(year?.value ? Number(year.value) : thisYear);
        }}
      />
    </>
  );
};
